import axios from "axios";

export default {
  state: {
    isShowing: false,
    currentAppName: null,
    messageSendedAt: Date,
  },
  getters: {
    getTitleOfCurrentApp(state) {
      return state.currentAppName;
    },
    getMessageDialog(state) {
      return state.isShowing;
    },
  },
  mutations: {
    showMessageDialog(state, payload) {
      state.currentAppName = payload;
      state.isShowing = true;
    },
    hideMessageDialog(state) {
      state.isShowing = false;
    },
  },
  actions: {
    sendMessageAction({ commit }, payload) {
      // setTimeout(() => {
      //   console.log("message sended", payload);
      // }, 1000);

      commit;

      let config = {
        headers: {
          lang: payload.lang,
        },
      };

      axios
        .post(`https://file.ilook.su/AppInfo/api/message/dev`, payload, config)
        .then((response) => response.data)
        .then((data) => {
          if (data && data.result) {
            this.messageSendedAt = new Date();
          }
        })
        .catch((error) => console.log(error));
    },
  },
};
